import React from "react"
import {createRoot} from 'react-dom/client'
import AlgoliaCollection from '../components/algolia/collection'
import {register} from '@shopify/theme-sections'
import '../../styles/sections/template-collection-listing.scss'
import '../../styles/sections/template-collection-algolia.scss'
import $ from 'jquery'
import CountdownTimer from '../../scripts/components/shared/countdown-timer'

export default register(`template-collection-algolia`, {
    onLoad() {
        const collectionContext = JSON.parse(this.container.querySelector(`[data-collection-json]`).innerHTML)
        const collectionsContext = JSON.parse(this.container.querySelector(`[data-collections-json]`).innerHTML)
        const navigationContext = JSON.parse(this.container.querySelector(`[data-navigation-json]`).innerHTML)
        const configAppCountry = this.container.dataset.shopCountry
        const shopifyAlgoliaIndex = this.container.dataset.algoliaIndex

        if (document.querySelector(`#countdown_container`)) {
            const countdownContainer = document.querySelector(`#countdown_container`)
            let countdownRoot = createRoot(countdownContainer)
            countdownRoot.render(
                <CountdownTimer
                    timezone={countdownContainer.dataset.timezone}
                    endDate={countdownContainer.dataset.endDate}
                />
            )
        }

        const algoliaContainer = document.querySelector(`#collection-root`)
        let algoliaRoot = createRoot(algoliaContainer)
        algoliaRoot.render(
            <AlgoliaCollection
                collection={collectionContext}
                collections={collectionsContext}
                navigation={navigationContext}
                country={configAppCountry}
                algoliaIndex={shopifyAlgoliaIndex}
            />
        )

        $(document).on(`click`, `.right-view-sort-main .view-inputs label[for="list"]`, () => {
            $(`#collection-root`).addClass(`collection-list-view`)
        })
        $(document).on(`click`, `.right-view-sort-main .view-inputs label[for="grid"]`, () => {
            $(`#collection-root`).removeClass(`collection-list-view`)
        })
        $(document).on(`click`, `#filterContainer .filters-title > span`, () => {
            $(`.custom-collection-layout #sidebar-content`).addClass(`sidebar-mobile-view`)
        })

    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
    },
})
